import axiosInstance from './axiosConfig';
import { setLocalStorageIfExists } from '../utils/setLocalStorageIfExists';

// Signup
export const signup = async (data) => {
  const response = await axiosInstance.post('/signup', data);
  if (response?.data?.success === true || response?.data?.success === "true") {
    localStorage.setItem('token', response?.data?.data?.token);
    setLocalStorageIfExists('email', response?.data?.data?.email);
    setLocalStorageIfExists('first_name', response?.data?.data?.first_name);
    setLocalStorageIfExists('last_name', response?.data?.data?.last_name);
    setLocalStorageIfExists('block-user', response?.data?.data?.is_blocked);
    localStorage.setItem('need_marketplace_account', response?.data?.data?.need_marketplace_account);
    localStorage.setItem('email_verify', response?.data?.data?.email_verify);
  }
  return response.data;
};

// Login
export const login = async (data) => {
  const response = await axiosInstance.post('/login', data);

  if (response?.data?.success === true || response?.data?.success === "true") {
    const userData = response?.data?.data;
    localStorage.setItem('token', userData?.token);
    setLocalStorageIfExists('email', userData?.email);
    setLocalStorageIfExists('first_name', userData?.first_name);
    setLocalStorageIfExists('last_name', userData?.last_name);
    setLocalStorageIfExists('block-user', userData?.is_blocked);
    localStorage.setItem('need_marketplace_account', userData?.need_marketplace_account);
    localStorage.setItem('email_verify', userData?.email_verify);

    const existingMarketplaceAcc = localStorage.getItem('marketplaceAcc');

    const isInvalidMarketplace =
      !existingMarketplaceAcc ||
      existingMarketplaceAcc === 'null' ||
      existingMarketplaceAcc === 'undefined' ||
      existingMarketplaceAcc === '{}' ||
      existingMarketplaceAcc.trim() === '';

    const marketplaceArr = userData?.marketplace;
    const firstMarketplace = Array.isArray(marketplaceArr) && Array.isArray(marketplaceArr[0])
      ? marketplaceArr[0]
      : null;

    if (isInvalidMarketplace && firstMarketplace) {
      const [id, text] = firstMarketplace;
      if (id && text) {

        localStorage.setItem('marketplaceAcc', JSON.stringify({ id, text }));
      }
    } else {
      console.log('already have')
    }
  }

  return response.data;
};


// Logout
export const logout = async () => {
  const response = await axiosInstance.delete('/logout');
  return response.data;
};

// Forgot Password
export const forgotPassword = async (data) => {
  const response = await axiosInstance.post('/password/forgot', data);
  return response.data;
};

// unlock account api 
export const unlockAccount = async (data) => {
  const response = await axiosInstance.post('unlock', data);
  return response.data;
};

export const verifyForgotEmail = async (data) => {
  const response = await axiosInstance.post('/password/verify', data);
  return response.data;
};

// Reset Password
export const resetPassword = async (data) => {
  const reset_password_token = localStorage.getItem("reset_password_token");
  const wrappedData = {
    user: {
      password: data?.user?.password,
      password_confirmation: data?.user?.password_confirmation,
      reset_password_token: reset_password_token
    }
  };
  const response = await axiosInstance.put('/password/reset', wrappedData);
  return response.data;
};


// Verify OTP
export const verifyOtp = async (data) => {
  const response = await axiosInstance.post(`/verify?type=${data.type}&otp=${data.otp}`);
  return response.data;
};

// Resend OTP
export const resendOtp = async (data) => {
  const response = await axiosInstance.post(`/resend?type=${data.type}`);
  return response.data;
};


// contact us api
export const contactUs = async (data) => {
  const response = await axiosInstance.post('/contact_messages', data);
  return response.data;
};

// enterprisePlan us api
export const enterprisePlan = async (data) => {
  const response = await axiosInstance.post('/onboarding/save', data);
  return response.data;
};


// profile status getting api 
export const getProfileStatus = async (accountId) => {
    const response = await axiosInstance.get('/profile/status', {
    headers: accountId ? { 'marketplace-id': accountId } : {},
  });

  return response.data;
};

// admin login page to login direct customer api
export const adminPageLogin = async (data) => {
  const response = await axiosInstance.post('/admin_login_as_user', data);
  return response.data;
};


// permission json 

export const getPermissionJson= async () =>{
  return await axiosInstance.get('subscriptions/user_plan_permissions');
}